import React from "react";

const MapTooltip = ({ children }) => (
  <div
    style={{
      position: "absolute",
      top: "16px",
      right: "16px",
      zIndex: 100,
      background: "white",
      padding: "10px",
      borderRadius: "6px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      pointerEvents: "none",
      maxWidth: "250px",
    }}
  >
    {children}
  </div>
);

export default MapTooltip;
